const getListOfAppliedFilters = (allQueryStrings: any) => {
  const appliedBqFilters = allQueryStrings["bq"];

  if (!appliedBqFilters) {
    return [];
  }
  const queryParts =
    appliedBqFilters?.split("|")?.filter((item) => item.length > 0) || [];

  const listOfChips = queryParts
    ?.map((item) => {
      const categoryKey = item.split(":")[0];
      const subFilters = item.split(":")[1].split(",");

      const list = subFilters.map((val) => {
        const obj = { categoryKey, filterKey: val };
        return obj;
      });

      return list;
    })
    .flat();

  return listOfChips;
};

export default getListOfAppliedFilters;
